<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>TX录入</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content">
      <el-tabs :value="activeTab" @tab-click="handleTabChange">
        <el-tab-pane label="所有" :name="''"></el-tab-pane>
        <el-tab-pane label="已提交" :name="1"></el-tab-pane>
        <el-tab-pane label="提现成功" :name="0"></el-tab-pane>
        <el-tab-pane label="失败" :name="-1"></el-tab-pane>
        <el-tab-pane label="已取消" :name="2"></el-tab-pane>
      </el-tabs>
      <div class="page-actions">
        <el-input placeholder="请输入账号ID" clearable v-model="userid">
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
          <el-button slot="append" @click="handleSearch" type="primary"
            >搜索</el-button
          >
        </el-input>
        <create @refresh="getList"></create>
      </div>
      <list @refresh="getList"></list>
    </el-card>
  </div>
</template>

<script>
import './store';
import { mapActions, mapState, mapMutations } from 'vuex';
import List from './components/list';
import Create from './components/create';

export default {
  name: 'TXRRecord',
  data() {
    return {
      userid: undefined
    };
  },
  components: {
    List,
    Create
  },
  computed: {
    ...mapState('txRecord', ['pagination', 'records', 'activeTab'])
  },
  methods: {
    ...mapActions('txRecord', ['getCoinTypes', 'getRecords']),
    ...mapMutations('txRecord', ['changeTab']),
    handleSearch() {
      this.getList({ page: 1 });
    },
    handleTabChange(tab) {
      this.changeTab(tab.name);
      this.getList({ page: 1 });
    },
    getList(data = {}) {
      this.getRecords({
        userid: this.userid,
        status: this.activeTab,
        coinType: this.coinType,
        ...this.pagination,
        ...data
      });
    }
  },
  created() {
    this.getCoinTypes();
    this.getList();
  }
};
</script>
